import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export const formatDateIfValid = (value: string | number | null) => {
  if (typeof value !== 'string' || !value) {
    return value;
  }

  const date = dayjs(value, 'YYYY-MM-DD', true);

  if (!date.isValid()) {
    return value;
  }

  return date.format('DD.MM.YY');
};
